import React from 'react';
import PropTypes from 'prop-types';

function Delete({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.364 5H8.727L3 12l5.727 7h10.637c.434 0 .85-.184 1.157-.513.307-.328.479-.773.479-1.237V6.75c0-.464-.172-.91-.48-1.237A1.584 1.584 0 0019.365 5v0zM17 9l-6 6M11 9l6 6"
      />
    </svg>
  );
}

Delete.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Delete;
